export default __webpack_public_path__ + "static/media/peopleperhour.7b38c4f7.svg";